import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { WerkzoekenFeedComparisonDto } from "./types";
import { jobSyncQueryKeys } from "../query-keys";

import { instance } from "@/lib/axios/instance";

export function useWerkzoekenFeedComparison(
  clientId: string | undefined
): UseQueryResult<WerkzoekenFeedComparisonDto, AxiosError> {
  return useQuery({
    queryKey: jobSyncQueryKeys.feedComparison("werkzoeken", clientId),
    queryFn: () =>
      instance
        .get<WerkzoekenFeedComparisonDto>(
          `/api/v2/Integrations/werkzoeken/job-sync/feed-registration-comparison`,
          {
            params: {
              clientId,
            },
          }
        )
        .then((res) => {
          const raw = res.data as unknown;
          const paginated = raw as {
            data?: Array<Record<string, unknown>>;
            Data?: Array<Record<string, unknown>>;
          };
          const item =
            Array.isArray(paginated?.data) && paginated.data[0] != null
              ? paginated.data[0]
              : Array.isArray(paginated?.Data) && paginated.Data[0] != null
                ? paginated.Data[0]
                : (raw as Record<string, unknown>);
          return {
            isMismatched: (item.IsMismatched ?? item.isMismatched) ?? false,
            isFeedUrlMismatched: (item.IsFeedUrlMismatched ?? item.isFeedUrlMismatched) ?? false,
            werkzoekenFeedId: item.WerkzoekenFeedId ?? item.werkzoekenFeedId ?? null,
            werkzoekenFeedUrl: item.WerkzoekenFeedUrl ?? item.werkzoekenFeedUrl ?? null,
          } as WerkzoekenFeedComparisonDto;
        }),
    enabled: !!clientId,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
